// precision: 'raw' (default) | 'int' | 'decimal'  (1 decimal place)
function LiveGameStatRow({
	gameState,
	label,
	icon,
	path,
	altPath,
	precision = 'raw',
}) {
	function resolve(player, dotPath) {
		if (!player || !dotPath) return undefined
		return dotPath.split('.').reduce((acc, key) => acc?.[key], player)
	}

	function display(value) {
		if (value === undefined || value === null) return '—'
		const n = Number(value)
		if (precision === 'int') return Math.floor(n)
		if (precision === 'decimal') return n.toFixed(1)
		return value
	}

	function calculateTCIdleTime(tcIdle) {
		let totalSeconds = tcIdle?.ticksTotal / 8
		let totalActiveSeconds = tcIdle?.ticksActive / 8

		let totalIdleTime = totalSeconds - totalActiveSeconds

		let minutes = Math.floor(totalIdleTime / 60)
		let seconds = Math.floor(totalIdleTime % 60)

		return `${minutes}:${seconds.toString().padStart(2, '0')}`
	}

	function calculateTCEfficiency(tcIdle) {
		let totalSeconds = tcIdle?.ticksTotal / 8
		let totalActiveSeconds = tcIdle?.ticksActive / 8
		return ((totalActiveSeconds / totalSeconds) * 100).toFixed(1)
	}

	const leftVal = resolve(gameState?.leftPlayer, path)
	const rightVal = resolve(gameState?.rightPlayer, path)
	const leftAlt = resolve(gameState?.leftPlayer, altPath)
	const rightAlt = resolve(gameState?.rightPlayer, altPath)

	const hasAlt = altPath !== undefined

	return (
		<div className="grid grid-cols-3 items-center text-sm text-white w-full">
			<div className="text-right pr-2 tabular-nums">
				<span>{display(leftVal)}</span>
				{hasAlt && leftAlt != null && (
					<>
						{' '}
						<i className="text-zinc-400 not-italic">
							(<i>{display(leftAlt)}</i>)
						</i>
					</>
				)}
			</div>

			<div className="flex items-center justify-center gap-1 px-1">
				{icon && (
					<img
						src={icon}
						alt=""
						className="h-4 w-4 object-contain shrink-0"
					/>
				)}
				{label && (
					<span className="text-[10px] font-semibold text-zinc-400 uppercase tracking-wide">
						{label}
					</span>
				)}
			</div>

			<div className="text-left pl-2 tabular-nums">
				<span>{display(rightVal)}</span>
				{hasAlt && rightAlt != null && (
					<>
						{' '}
						<i className="text-zinc-400 not-italic">
							(<i>{display(rightAlt)}</i>)
						</i>
					</>
				)}
			</div>
		</div>
	)
}

export default LiveGameStatRow
